import { assert_is_safe_number, assert_number_gte_0, assert_string_not_empty, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { EWorkspaceCreditTransactonType } from './EWorkspaceCreditTransactonType';

export class DTOWorkspaceCreditTransaction extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.WORKSPACE_CREDIT_TRANSACTION;

  //STATIC METHODS

  /*
   * DB FIELDS
   */
  workspace_id!: string;
  user_id_creator!: string;

  related_entity_id!: string;
  type!: string;

  value!: number;
  balance_before!: number;
  balance_after!: number;

  /*
   * RUNTIME FIELDS
   */
  creator_name!: string;
  creator_avatar_url_relative!: string;

  /*
   * METHODS
   */
  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_string_not_empty(this.workspace_id);
    assert_string_not_empty(this.user_id_creator);

    assert_type_enum(this.type, EWorkspaceCreditTransactonType);

    assert_is_safe_number(this.value);
    assert_number_gte_0(this.balance_before);
    assert_number_gte_0(this.balance_after);

    assert_string_not_empty(this.creator_name);
  }
}
